import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import { useHistory } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Select } from "antd";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Loading from "../../components/Common/Loading";

function CreateSocialNews(props) {
  const [categories, setCategories] = useState([]);
  const [image, setImage] = useState(null);
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);

  const { Option } = Select;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const history = useHistory();
  const user = useSelector((state) => state.User);
  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get settings
  const getCategories = () => {
    setIsLoading(true);
    apiReq(url.GET_SOCIAL_CATEGORY, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setCategories(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getCategories();
  }, []);

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "news",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // Handle Cnahge Category
  const handleChangeCategory = (value) => {
    setSelectedCategory(value);
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  const slugify = (text) => {
    const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    const to = "aaaaaeeeeeiiiiooooouuuunc------";

    const newText = text
      .split("")
      .map((letter, i) =>
        letter.replace(new RegExp(from.charAt(i), "g"), to.charAt(i))
      );

    return newText
      .toString() // Cast to string
      .toLowerCase() // Convert the string to lowercase letters
      .trim() // Remove whitespace from both sides of a string
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/&/g, "-y-") // Replace & with 'and'
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-"); // Replace multiple - with single -
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (image === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Upload Image",
      });
      return;
    } else {
      setIsLoading(true);
      apiReq(
        url.CREATE_SOCIAL_NEWS_ITEMS,
        {
          title: data.title,
          description: data.description,
          category: selectedCategory,
          image: image,
          slug: slugify(data.title),
          content: content,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            history.push("/social/list");
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Create Social News</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label>Image</label>
                      <div
                        className="dropzone p-4 mb-3"
                        style={{ minHeight: 120 }}
                      >
                        {!image ? (
                          <div
                            className="needsclick"
                            // {...getRootProps()}
                          >
                            {/* <input /> */}
                            <div className="mb-3">
                              <i className="ri-image-line display-4 text-muted"></i>
                            </div>
                            <h5 className="opacity-40">Featured Image</h5>
                            <input
                              type="file"
                              className="image_upload_input"
                              onChange={(e) => handleLogoUpload(e)}
                            />
                          </div>
                        ) : (
                          <div className="filled_image">
                            <img
                              src={image}
                              alt="image"
                              className="img-fluid"
                            />
                            <div
                              className="remove_image"
                              onClick={() => setImage(null)}
                            >
                              <i className="mdi mdi-close-thick"></i>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter title"
                        {...register("title", { required: true })}
                      />
                      {errors.title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label>Category</label>
                    {/* <select
                      className="form-control"
                      {...register("category", { required: true })}
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category._id}>
                          {category.title}
                        </option>
                      ))}
                    </select>
                    {errors.category && (
                      <span className="text-danger">Category is required</span>
                    )} */}
                    <Select
                      mode="multiple"
                      style={{
                        width: "100%",
                        height: 40,
                      }}
                      placeholder="select category"
                      defaultValue={selectedCategory}
                      onChange={handleChangeCategory}
                      optionLabelProp="label"
                      className="custom_selector"
                    >
                      {categories.map((item, index) => (
                        <Option
                          value={item._id}
                          label={item.title}
                          key={`index${index + 22}`}
                        >
                          <div
                            className="demo-option-label-item"
                            style={{ height: 40 }}
                          >
                            {item.title}
                          </div>
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>

                <div className="mb-3">
                  <label>Short Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter short description"
                    {...register("description", { required: true })}
                  />
                  {errors.description && (
                    <span className="text-danger">
                      Short Description is required
                    </span>
                  )}
                </div>
                <div className="mb-3 privacy_editor">
                  <label>News Content</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={content}
                    style={{ minHeight: "130px" }}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      console.log("Editor is ready to use!", editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setContent(data);
                      // console.log({ event, editor, data });
                    }}
                    onBlur={(event, editor) => {
                      console.log("Blur.", editor);
                    }}
                    onFocus={(event, editor) => {
                      console.log("Focus.", editor);
                    }}
                  />
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>Meta Title</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>Meta Description</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button type="submit" className="btn btn-primary">
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CreateSocialNews;
